export const BookingForm = {
  en: {
    'Booking Settings': 'Booking Settings',
    'Edit Booking Settings': 'Booking Settings',
    'Update Booking Settings': 'Save',
    'Cutoff before start': 'Cutoff before start (minutes)',
    cutoff_hint:
      'How long before an event starts a client may still book it, so they have time to get there. Shared with the legacy booking.',
    'Booking horizon': 'Booking horizon (days)',
    horizon_hint:
      'How far ahead a client may book online. The admin calendar is not limited by it.',
    'Personal booking description': 'Personal booking description',
    personal_booking_description_hint:
      'Shown to the client in the personal booking flow.',
    'Group booking description': 'Group booking description',
    group_booking_description_hint:
      'Shown to the client in the group booking flow.',
    'Event booking description': 'Event booking description',
    event_booking_description_hint:
      'Shown to the client in the club event registration flow.',
    'Trainer order': 'Trainer order',
    'Trainer order hint':
      'Drag the trainers into the order clients see them in when booking. Only specialists are listed; the order saves immediately.',
    'No specialists available': 'No specialists yet.',
  },
  uk: {
    'Booking Settings': 'Налаштування бронювання',
    'Edit Booking Settings': 'Налаштування бронювання',
    'Update Booking Settings': 'Зберегти',
    'Cutoff before start': 'Останній момент для запису (хвилини)',
    cutoff_hint:
      'За скільки хвилин до початку клієнт ще може записатися, щоб устигнути дістатися вчасно. Спільне зі старим бронюванням.',
    'Booking horizon': 'Горизонт бронювання (дні)',
    horizon_hint:
      'На скільки днів наперед клієнт може записатися онлайн. Календар адміністратора цим не обмежений.',
    'Personal booking description': 'Опис персонального бронювання',
    personal_booking_description_hint:
      'Показується клієнту у флоу персонального бронювання.',
    'Group booking description': 'Опис групового бронювання',
    group_booking_description_hint:
      'Показується клієнту у флоу групового бронювання.',
    'Event booking description': 'Опис запису на подію клубу',
    event_booking_description_hint:
      'Показується клієнту у флоу запису на подію клубу.',
    'Trainer order': 'Порядок тренерів',
    'Trainer order hint':
      'Перетягніть тренерів у порядку, в якому їх бачить клієнт під час бронювання. У списку лише спеціалісти; порядок зберігається одразу.',
    'No specialists available': 'Спеціалістів ще немає.',
  },
};
